import React from "react";
import {Box, CircularProgress} from "@emburse/ui-core";
import {Header} from "../Header/Header";

/**
 * This component will display the progress loading page.
 */
export const ConfigurationLoading = () => {
    return (
        <>
            <Header/>
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
                <CircularProgress/>
            </Box>
        </>
    );
};